import { Base } from '../base-component';

import './article-page-image-carousel-item.component.scss';
import SliderComponent from '../slider/slider.component';
import { MediaQueryService } from '../../services/media-query.service';

export class ArticlePageImageCarouselItem extends Base {

	constructor(element){
		super(element)
	}

	init(){};

	bindEvents(){};

}



// WEBPACK FOOTER //
// ./components/article-page-image-carousel-item/article-page-image-carousel-item.component.ts